import { ILangsAvailable } from '../../src/utils/interface'

export const LANGS_AVAILABLE: ILangsAvailable[] = [
  { default: true, label: 'Español', value: 'es' },
  { default: false, label: 'English', value: 'en' }
]
